
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fyrirtaeki/birgjamat",
      function () {
        return require("private-next-pages/fyrirtaeki/birgjamat.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fyrirtaeki/birgjamat"])
      });
    }
  